export interface TrainingRecordSignableItem {
  signatureFileId?: string | null;
}

export function canGenerateTrainingRecord(
  items: TrainingRecordSignableItem[]
): boolean {
  return items.length > 0;
}

export function getTrainingRecordGenerationMessage(
  items: TrainingRecordSignableItem[]
): string {
  const signed = items.filter((item) => !!item.signatureFileId).length;
  const total = items.length;
  return signed < total
    ? `${signed} of ${total} employees have signed. Generate training record anyway?`
    : 'Are you sure you want to generate a training record?';
}

export function toTrainingRecordUint8Array(data: unknown): Uint8Array | null {
  if (!data) {
    return null;
  }

  if (data instanceof Uint8Array) {
    return data;
  }

  if (data instanceof ArrayBuffer) {
    return new Uint8Array(data);
  }

  if (ArrayBuffer.isView(data)) {
    return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
  }

  return null;
}

export function decodeTrainingRecordErrorPayload(
  payload: unknown
): string | null {
  if (typeof payload === 'string') {
    return payload;
  }

  if (payload && typeof payload === 'object') {
    const detail = (payload as { detail?: unknown }).detail;
    if (typeof detail === 'string' && detail.trim()) {
      return detail;
    }

    const message = (payload as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }

  const bytes = toTrainingRecordUint8Array(payload);

  if (!bytes || bytes.length === 0) {
    return null;
  }

  const text = Buffer.from(bytes).toString('utf8').trim();
  if (!text) {
    return null;
  }

  try {
    const parsed = JSON.parse(text) as { detail?: unknown; message?: unknown };
    if (typeof parsed.detail === 'string' && parsed.detail.trim()) {
      return parsed.detail;
    }

    if (typeof parsed.message === 'string' && parsed.message.trim()) {
      return parsed.message;
    }
  } catch {
    return text;
  }

  return text;
}

export function getTrainingRecordPdfFileName(
  trainingId: string,
  contentDisposition: string | null
): string {
  const match = contentDisposition
    ? /filename\*?=(?:UTF-8'')?([^;]+)/.exec(contentDisposition)
    : null;
  const extractedFileName = match
    ? decodeURIComponent(match[1].trim()).replace(/\.pdf$/i, '')
    : 'trainingCompletion';

  return `${extractedFileName}_${trainingId}.pdf`;
}
